<div class="envio-simple-page">
  <h1 class="envio-simple-page__title">Envío simple</h1>

  <app-envio-simple-stepper
    [elementos]="envioSimpleFlowService.PASOS"
    [stepActive]="envioSimpleFlowService.pasoActivo">
  </app-envio-simple-stepper>

  <section class="envio-simple-card envio-simple-card--dropzone">
    <app-envio-simple-zona-carga></app-envio-simple-zona-carga>
  </section>

  <section class="envio-simple-card envio-simple-card--files">
    <app-envio-simple-ficheros-subidos></app-envio-simple-ficheros-subidos>
  </section>
</div>

<div class="envio-simple-footer">
  <div class="envio-simple-footer__left">
    <app-boton-accion-secundaria (click)="atras()" [id]="'atras'" [icono]="'hs-arrow-back'" [titulo]="'volver'"></app-boton-accion-secundaria>
  </div>
  <div class="envio-simple-footer__right botonera-rigth" (click)="onContinuarClick()">
    <app-boton-accion [id]="'siguiente-envio-simple'" [titulo]="'Siguiente'" [disabled]="!tieneDocumentos" (botonClicked)="siguiente()"></app-boton-accion>
  </div>
</div>